import { useMeasure } from "@uidotdev/usehooks";
import { useEffect, useRef, useState } from "react";

type AnimatedHeightReturn = {
  ref: (element: HTMLElement | null) => void;
  animatedHeight: number | "auto";
};

export function useAnimatedHeight(isVisible: boolean): AnimatedHeightReturn {
  const [ref, { height }] = useMeasure();
  const [animatedHeight, setAnimatedHeight] = useState<number | "auto">("auto");
  const previousHeight = useRef<number>(0);

  useEffect(() => {
    if (typeof height === "number" && height > 0) {
      if (isVisible) {
        // Expanding: Set to 0 first if it was collapsed, then to measured height
        if (previousHeight.current === 0) {
          setAnimatedHeight(0);
          requestAnimationFrame(() => {
            setAnimatedHeight(height);
          });
        }
        else {
          setAnimatedHeight(height);
        }
        previousHeight.current = height;
      }
      else {
        // Collapsing: Set to current height first, then to 0
        previousHeight.current = height;
        setAnimatedHeight(height);
        requestAnimationFrame(() => {
          setAnimatedHeight(0);
        });
      }
    }
    else if (!isVisible) {
      // If not visible and no height measured yet, ensure it's 0
      setAnimatedHeight(0);
      previousHeight.current = 0;
    }
  }, [isVisible, height]);

  return { ref, animatedHeight };
}
